import React from 'react';
import PRODUCTS from './plantList'
function ProductRowComponent({product}){
    const name = product.stocked ?
    product.name :
    <span style={{color:'red'}}>{product.name}</span>
    return <tr>
        <td>{name}</td>
        <td>{product.price}</td>
    </tr>
}   
const ProductRow = React.memo(ProductRowComponent)
function ProductCategoryRow({category}){
    return <tr>
        <th colSpan="2" >{category}</th>
    </tr>
}
function ProductTable({products,filterText,stockage}){
    const rows = []
    let last = null
    products.forEach(product =>{
        if (stockage && !product.stocked){
            return
        }
        if (product.name.indexOf(filterText)===-1){
            return
        }
        if (product.category !== last){
            last = product.category
            rows.push(<ProductCategoryRow key={last} category={product.category}/>)
        }
        rows.push(<ProductRow key={product.name} product={product}/>)
    }   )
    return <table>
        <thead>
            <tr>
                <th>Nom</th>
                <th>Prix</th>
            </tr>
        </thead>
        <tbody>
            {rows}
        </tbody>
    </table>
}
class Rechercche extends React.Component{
        constructor(props){
            super(props)
            this.handelfiltertext=this.handelfiltertext.bind(this)
            this.handelfilerstock=this.handelfilerstock.bind(this)
        }

        handelfiltertext(e){
            this.props.onFilterTextXhange(e.target.value)
            console.log(e.target.value)
            console.log(this.props.onFilterTextXhange)
        }
        handelfilerstock(e){
            this.props.onStockChange(e.target.checked)
        }
        render(){
            const {filterText,stockage} =this.props
            return <div>
                <div>
                    <input type="text" value={filterText} onChange={this.handelfiltertext} placeholder='Recherhe'/>
                </div>
                <div>
                    <input type="checkbox" checked={stockage} onChange={this.handelfilerstock} id='stock'/>
                    <label htmlFor="stock" >Produit stock</label>
                </div>
            </div>
        }
}

class Find extends React.Component{
    constructor(props){
        super(props)
        this.state = {
            filterText : 'Foot',
            stockage : false
        }
        this.handelfilerstock = this.handelfilerstock.bind(this)
        this.handelfiltertext = this.handelfiltertext.bind(this)

    }

    handelfiltertext(filterText){
         this.setState({
            filterText : filterText
        }
            )
        }
    
    handelfilerstock(stockage){
        this.setState({stockage : stockage

        } )
    }
    render(){
        const {products} = this.props
        return <React.Fragment>

            {JSON.stringify(this.state)}
            <Rechercche 
            filterText={this.state.filterText}
            stockage={this.state.stockage}
            onFilterTextXhange = {this.handelfiltertext}
            onStockChange = {this.handelfilerstock}
            />
            <ProductTable 
            filterText={this.state.filterText}
            stockage={this.state.stockage}
            products={products}/>
        </React.Fragment>
    }
}
function Filtre(){
    return <Find products={PRODUCTS}/>
}
export default Filtre;